module.exports = __webpack_public_path__ + "3bdefe21fa1436cf942e48bd5ace0fdf.svg";